var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 56,
    r: 56,
    fill: "#FAFAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.3341 36.7428C84.6618 38.051 84.6618 40.1719 83.3341 41.48L49.0512 75.2562C47.7235 76.5644 45.5708 76.5644 44.243 75.2562L28.6599 59.9034C27.3321 58.5953 27.3321 56.4743 28.6599 55.1662C29.9876 53.8581 32.1404 53.8581 33.4681 55.1662L46.6471 68.1504L78.5258 36.7428C79.8536 35.4347 82.0063 35.4347 83.3341 36.7428Z",
    fill: "#B1B0F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.7634 49.9238L66.1927 58.3679L49.0513 75.256C47.7235 76.5641 45.5708 76.5641 44.243 75.256L28.6599 59.9032C27.3321 58.595 27.3321 56.4741 28.6599 55.166C29.9876 53.8578 32.1404 53.8578 33.4681 55.166L46.6471 68.1502L54.6168 60.2983L74.7634 49.9238Z",
    fill: "#8E8CEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.98361bd6926342968730973dd8cd9be4.svg";
export { ForwardRef as ReactComponent };